<template>
  <button class="bg-yellow-400 rounded-lg py-2 px-3 text-white">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "Button"
}
</script>

<style scoped>

</style>